import { render, staticRenderFns } from "./Dependants.vue?vue&type=template&id=290ba7c4"
import script from "./Dependants.vue?vue&type=script&lang=js"
export * from "./Dependants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports